import { Dispatch } from 'redux';
import {
  POLICY_DELIVERY_DOWNLOAD_FAILED,
  POLICY_DELIVERY_DOWNLOAD_START,
  POLICY_DELIVERY_DOWNLOAD_SUCCESS,
  POLICY_DELIVERY_FAILED,
  POLICY_DELIVERY_START,
  POLICY_DELIVERY_SUCCESS
} from './types';
import { ApiClient } from '../api.client';
import { ReduxStore } from '../payload-types';
import { LINKS } from '@trip-ux/constants';
import { map } from 'lodash';
import { interpolateTemplate } from '@trip-ux/common';

export const getPolicyDeliveries =
  (policyNumbers: string[]) =>
  (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<void> => {
    dispatch({ type: POLICY_DELIVERY_START });

    return Promise.all(
      map(policyNumbers, policyNumber =>
        apiClient(dispatch, getState).get(interpolateTemplate(LINKS.POLICYDELIVERY, { policyNumber }))
      )
    )
      .then(payload => {
        dispatch({ type: POLICY_DELIVERY_SUCCESS, payload });
      })
      .catch(e => {
        dispatch({ type: POLICY_DELIVERY_FAILED, payload: e });
      });
  };

export const getPolicyDeliveryConfirmation =
  (policyNumber: string, referenceNumber: string, lang: string, emailRef: string = '') =>
  (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<unknown> => {
    dispatch({ type: POLICY_DELIVERY_DOWNLOAD_START, payload: `${policyNumber}*${referenceNumber}*${emailRef}` });
    const pdfLink = `${LINKS.POLICYPDF}${emailRef ? `?emailRef=${emailRef}` : ''}`;

    return apiClient(dispatch, getState)
      .get(interpolateTemplate(pdfLink, { policyNumber }), {
        responseType: 'arraybuffer',
        headers: { lang }
      })
      .then(payload => {
        dispatch({
          type: POLICY_DELIVERY_DOWNLOAD_SUCCESS,
          payload: new Blob([new Uint8Array(payload.data)], { type: 'application/pdf' })
        });
      })
      .catch(e => {
        dispatch({ type: POLICY_DELIVERY_DOWNLOAD_FAILED, payload: e });
      });
  };
